import React, { useEffect, useState } from 'react';
import Template0 from '../../templates/template0';
import Template5 from '../../templates/template5';
import Template4 from '../../templates/template4';
import Template2 from '../../templates/template2';
import Template1 from '../../templates/template1';

import SectionTextArea from './section-textarea';
import TemplateMatchText from '../../templates/template-text-match';
import TempalteStatement from '../../templates/template-statement';
import TemplateRankingText from '../../templates/template-ranking-text';
import TemplateDragText from '../../templates/template-drag-text';
import MultipleChoiceTemplate from '../../templates/MultiChoiceTemplate';
import useWidth from '@/helpers/widthUtil';

const SectionContainer = ({
  section,
  listenFromHere,
  model,
  answers,
  scrollToQ,
  setAns,
  setAnswer,
}) => {
  const [qCounter, setQcounter] = useState(0);
  const [updatedSection, setSection] = useState(section);
  const { isMobile } = useWidth();
  useEffect(() => {
    setSection(section);
  }, [section]);

  useEffect(() => {
    setSection(section);
  }, [section]);

  return (
    <div className={`section-caption mt-2 ${isMobile ? 'mb-2' : 'mb-5'}`}>
      <SectionTextArea
        title={`${updatedSection?.title}`}
        questionDetail={`QUESTIONS ${
          updatedSection.question_from && updatedSection.question_to
            ? `${updatedSection.question_from} - ${updatedSection.question_to}`
            : ''
        }`}
        className="test"
        listenFromHere={listenFromHere}
        context={updatedSection?.context}
        marks={updatedSection?.marks}
        total_q={updatedSection?.total_q}
        total_marks={updatedSection?.total_marks}
      />
      <div>
        {updatedSection.question.map((q, i) => (
          <div key={i}>
            {q.question_type == 3 && (
              <Template5
                question={q}
                section={updatedSection.id}
                model={model}
                title={q.title}
                setAns={setAns}
                context={q.context}
                scrollToQ={scrollToQ}
                answers={answers}
                setAnswer={setAnswer}
              />
            )}
            {q.question_type == 0 && (
              <Template4
                question={q}
                scrollToQ={scrollToQ}
                section={updatedSection.id}
                model={model}
                setAns={setAns}
                answers={answers}
                setAnswer={setAnswer}
              />
            )}
            {q.question_type == 1 && (
              // <Template1
              //   question={q}
              //   section={updatedSection.id}
              //   model={model}
              //   scrollToQ={scrollToQ}
              //   setAns={setAns}
              //   answers={answers}
              //   setAnswer={setAnswer}
              // />
              <MultipleChoiceTemplate
                question={q}
                section={updatedSection.id}
                model={model}
                scrollToQ={scrollToQ}
                setAns={setAns}
                answers={answers}
                setAnswer={setAnswer}
              />
            )}
            {q.question_type == 2 && (
              <Template2
                question={q}
                scrollToQ={scrollToQ}
                section={updatedSection.id}
                model={model}
                setAns={setAns}
                answers={answers}
                setAnswer={setAnswer}
              />
            )}
            {q.question_type == 4 && (
              <TemplateMatchText
                question={q}
                section={updatedSection.id}
                model={model}
                scrollToQ={scrollToQ}
              />
            )}
            {q.question_type == 5 && (
              <TemplateDragText
                question={q}
                section={updatedSection.id}
                model={model}
              />
            )}
            {q.question_type == 6 && (
              <TempalteStatement
                question={q}
                section={updatedSection.id}
                model={model}
              />
            )}
            {q.question_type == 7 && (
              <TemplateRankingText
                question={q}
                section={updatedSection.id}
                model={model}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionContainer;
